import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { get_all_user_submissions } from '../../redux/actions/submissionActions'
import { get_all_users } from '../../redux/actions/userAuthActions'
import avatar from '../../assets/avatar-4.png'
import { Link } from 'react-router-dom'
import Loader from '../../components/Loader'
import {
	ADMIN_GET_ALL_SUBMISSIONS_RESET,
	GET_CURRENT_CAMPAIGN_RESET,
	GET_ALL_USERS_RESET,
} from '../../redux/types'
import { get_current_campaign_user } from '../../redux/actions/campaignActions'
import CampaignSlider from '../../components/CampaignSlider'

const DashboardHome = () => {
	const dispatch = useDispatch()

	const adminAuth = useSelector((state) => state.adminAuth)
	const { loading, detail } = adminAuth

	const getCurrentCampaign = useSelector((state) => state.getCurrentCampaign)
	const { currentCampaign } = getCurrentCampaign

	const getAllSubmissions = useSelector((state) => state.getAllSubmissions)
	const { submissions } = getAllSubmissions

	const getAllUsers = useSelector((state) => state.getAllUsers)
	const { users } = getAllUsers

	useEffect(() => {
		dispatch(get_current_campaign_user())
		dispatch(get_all_user_submissions())
		dispatch(get_all_users())

		return () => {
			dispatch({ type: GET_CURRENT_CAMPAIGN_RESET })
			dispatch({ type: ADMIN_GET_ALL_SUBMISSIONS_RESET })
			dispatch({ type: GET_ALL_USERS_RESET })
		}
	}, [dispatch])

	return (
		<>
			<section className='user_dashboard'>
				{loading ? (
					<Loader />
				) : detail ? (
					<div className='container'>
						<div className='row justify-content-center'>
							<div className='col-md-9'>
								<div className='row'>
									<div className='col-md-6'>
										<div className='user_dashboard_dashboard_box'>
											{detail.profileImage ? (
												<div className='home_image_box'>
													<img src={detail.profileImage} alt='' />
												</div>
											) : (
												<img src={avatar} alt='' />
											)}

											<p>
												{detail.firstName} {detail.lastName}
											</p>

											<hr />

											<p> {detail.email} </p>
										</div>
									</div>

									<div className='col-md-6'>
										<div className='user_dashboard_dashboard_box'>
											<p className='mt-4'> Total No of Submissions </p>
											<h1>
												{submissions &&
													submissions.submissions &&
													submissions.submissions.length}
											</h1>

											<hr />
										</div>
									</div>

									<div className='col-md-6'>
										<div className='user_dashboard_dashboard_box'>
											<p> Current Campaign(s) </p>

											{currentCampaign &&
												currentCampaign.map((e) => (
													<div
														className='d-flex'
														style={{ borderBottom: '1px solid rgba(0,0,0,.1)' }}
														key={e._id}
													>
														<div className='circle_dot'></div>
														<p> {e.name} </p>
													</div>
												))}
										</div>
									</div>

									<div className='col-md-6'>
										<div className='user_dashboard_dashboard_box'>
											<p className='mt-4'> No of Users </p>
											<h1>{users && users.users && users.users.length}</h1>
										</div>
									</div>

									<div className='col-md-12'>
										<div className='mt-5 mb-5'>
											<CampaignSlider />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				) : (
					'No data to be displayed'
				)}
			</section>
		</>
	)
}

export default DashboardHome
